import api from "./api";

const CustomerService = {
  create: async (data) => {
    const res = await api.post("/customers/save", data);
    return res.data;
  },

  getActiveCustomers: async (page = 1, limit = 20) => {
    const res = await api.get(`/customers/getActive?page=${page}&limit=${limit}`);
    return res.data;
  },

  getAll: async (page = 1, limit = 20, search = "") => {
    const res = await api.get(`/customers/getAll?page=${page}&limit=${limit}&search=${search}`);
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/customers/getById/${id}`);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/customers/updateCustomer/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/customers/${id}`);
    return res.data;
  },

  updateStatus: async (id) => {
    const res = await api.put(`/customers/updateStatus/${id}`);
    return res.data;
  },

  getByCompanyId: async (companyId) => {
    const res = await api.get(`/customers/getByCompany/${companyId}`);
    return res.data;
  },
};

export default CustomerService;
